import dynamic from 'next/dynamic';

import { showMoreTypeEnum } from '@com/shared/carousel';
import { clinicsTexts } from '@constant/clinics';
import ServiceCard from '@com/shared/cards/health-services';
import ServiceCardShimmer from '@com/shared/cards/health-services/shimer';
import type CarouselComponent from '@com/shared/carousel';
import { DoctorProfile } from '@models/ocs/doctor';
import useServiceBooking from '@hooks/useServiceBooking';
import { Fragment } from 'react';
import Divider from '@com/_atoms/Divider';
import { useGetDoctorClinic } from '@api/in-person-booking/index.rq';

const Carousel = dynamic(
  () => import('@com/shared/carousel'),
) as typeof CarouselComponent;

type ServicesCarouselProps = {
  doctorId: number;
  doctorProfile?: DoctorProfile;
};

const ServicesCarousel = ({
  doctorId,
  doctorProfile,
}: ServicesCarouselProps) => {
  const { data: clinicData } = useGetDoctorClinic(
    { doctorId: String(doctorId) },
    {
      enabled: !!doctorId,
    },
  );

  const {
    userServiceData,
    userServiceDataIsLoading,
    servicesCarouselRef,
    handleOpenServiceCalendar,
  } = useServiceBooking({
    doctorId,
    doctorProfile: doctorProfile,
    profileId: doctorProfile?.profileId,
  });

  if (!userServiceDataIsLoading && !userServiceData?.queryResult?.length) {
    return null;
  }

  return (
    <Fragment>
      <Divider padding={0} className="h-2 bg-surface-secondary mb-3" />

      <div ref={servicesCarouselRef}>
        <Carousel
          title={`خدمات ${doctorProfile?.fullName}`}
          items={userServiceData?.queryResult}
          ItemComponent={({ item }) => (
            <ServiceCard
              item={item}
              containerClassname="!h-[270px]"
              onClick={() =>
                handleOpenServiceCalendar({
                  service: item,
                  clinic: clinicData?.data?.[0],
                })
              }
            />
          )}
          shimmerCount={4}
          ShimmerComponent={<ServiceCardShimmer />}
          showMoreLabel={clinicsTexts?.viewMore}
          showMoreType={showMoreTypeEnum.NAKED}
          containerClassName="!h-[360px]"
          scrollSliderClassName="h-[310px] gap-x-3 pb-4"
        />
      </div>
    </Fragment>
  );
};

export default ServicesCarousel;
